import React from "react";

export default function Caption({ text }) {

  return (

    <div className="text-center">
      <div className="push60"/>
      <div className="title-h1">{text}</div>
    </div>

  );
}